import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { Button } from '@mui/material';
import { isNil } from 'lodash';
import {configuration } from 'apis';
import {useQuery } from 'react-query';
import { useRef, useState } from 'react';

const ChecklistScreen = () =>{
    const checklistTables = useRef();
    
    const seasonGridRef = useRef();
    const [seasonChanges, setSeasonChanges] = useState({});
    const [originalSeason, setOriginalSeason] = useState({});
    const [isSeasonChanged, setIsSeasonChanged] = useState(false);
    
    const eventsGridRef = useRef();
    const [eventsChanges, setEventsChanges] = useState({});
    const [originalEvents, setOriginalEvents] = useState({});
    const [isEventsChanged, setIsEventsChanged] = useState(false);
    
    const applicationTypeGridRef = useRef();
    const [applicationTypeChanges, setApplicationTypeChanges] = useState({});
    const [originalApplicationType, setOriginalApplicationType] = useState({});
    const [isApplicationTypeChanged, setIsApplicationTypeChanged] = useState(false);
    
    const applicationTypeProductAgesGridRef = useRef();
    const [applicationTypeProductAgesChanges, setApplicationTypeProductAgesChanges] = useState({});
    const [originalApplicationTypeProductAges, setOriginalApplicationTypeProductAges] = useState({});
    const [isApplicationTypeProductAgesChanged, setIsApplicationTypeProductAgesChanged] = useState(false);

    const applicationTypeProductServicesGridRef = useRef();
    const [applicationTypeProductServicesChanges, setApplicationTypeProductServicesChanges] = useState({});
    const [originalApplicationTypeProductServices, setOriginalApplicationTypeProductServices] = useState({});
    const [isApplicationTypeProductServicesChanged, setIsApplicationTypeProductServicesChanged] = useState(false);
    
    const fileTypesGridRef = useRef();
    const [fileTypesChanges, setFileTypesChanges] = useState({});
    const [originalFileTypes, setOriginalFileTypes] = useState({});
    const [isFileTypesChanged, setIsFileTypesChanged] = useState(false);

    const eventDataQuery = useQuery(['checklistScreenEvent'], async () => {
        const eventResult = await configuration.getLKEvents();
        console.log('eventResult', eventResult);
        return eventResult;
    });
    
    const seasonDataQuery = useQuery(['checklistScreenSeason'], async () => {
        const seasonResult = await configuration.getLKSeason();
        console.log('seasonResult', seasonResult);
        return seasonResult;
    });

    const applicationTypeProductAgesDataQuery = useQuery(['checklistScreenApplicationTypeProductAges'], async () => {
        const applicationTypeProductAgesResult = await configuration.getApplicationTypeProductAges();
        console.log('applicationTypeProductAgesResult', applicationTypeProductAgesResult);
        return applicationTypeProductAgesResult;
    });

    const applicationTypeProductServicesDataQuery = useQuery(['checklistScreenApplicationTypeProductServices'], async () => {
        const applicationTypeProductServicesResult = await configuration.getApplicationTypeProductServices();
        console.log('applicationTypeProductServicesResult', applicationTypeProductServicesResult);
        return applicationTypeProductServicesResult;
    });

    const fileTypesDataQuery = useQuery(['checklistScreenFileTypes'], async () => {
        const fileTypesResult = await configuration.getFileTypes();
        console.log('fileTypesResult', fileTypesResult);
        return fileTypesResult;
    });

    const applicationTypeDataQuery = useQuery(['checklistScreenApplicationType'], async () => {
        const applicationTypeResult = await configuration.getApplicationType();
        console.log('applicationTypeResult', applicationTypeResult);
        return applicationTypeResult;
    });

    const optionalAnswerDataQuery = useQuery(['checklistScreenOptionalAnswers'], async () => {
        const optionalAnswerResult = await configuration.getOptionalAnswers();
        console.log('optionalAnswerResult', optionalAnswerResult);
        return optionalAnswerResult;
    });

    const questionDataQuery = useQuery(['checklistScreenQuestion'], async () => {
        const questionResult = await configuration.getQuestion();
        console.log('questionResult', questionResult);
        return questionResult;
    });

    const handleSeason = () => {
        const season = Object.values(seasonChanges);
        configuration.postSeason(season);
        setSeasonChanges({});
        setOriginalSeason(prevOriginals => ({...prevOriginals, ...seasonChanges}));
        setIsSeasonChanged(false);
        console.log('season', season);
    };

    const handleApplicationType = () => {
        const applicationType = Object.values(applicationTypeChanges);
        configuration.postApplicationType(applicationType);
        setApplicationTypeChanges({});
        setOriginalApplicationType(prevOriginals => ({...prevOriginals, ...applicationTypeChanges}));
        setIsApplicationTypeChanged(false);
        console.log('applicationType', applicationType);
    };

    const handleEvents = () => {
        const events = Object.values(eventsChanges);
        configuration.postEvents(events);
        setEventsChanges({});
        setOriginalEvents(prevOriginals => ({...prevOriginals, ...eventsChanges}));
        setIsEventsChanged(false);
        console.log('events', events);
    };

    const handleApplicationTypeProductAges = () => {
        const applicationTypeProductAges = Object.values(applicationTypeProductAgesChanges);
        console.log("FOIVAN " , applicationTypeProductAges);
        configuration.postApplicationTypeProductAges(applicationTypeProductAges);
        setApplicationTypeProductAgesChanges({});
        setOriginalApplicationTypeProductAges(prevOriginals => ({...prevOriginals, ...applicationTypeProductAgesChanges}));
        setIsApplicationTypeProductAgesChanged(false);
    };

    const handleApplicationTypeProductServices = () => {
        const applicationTypeProductServices = Object.values(applicationTypeProductServicesChanges);
        configuration.postApplicationTypeProductServices(applicationTypeProductServices);
        setApplicationTypeProductServicesChanges({});
        setOriginalApplicationTypeProductServices(prevOriginals => ({...prevOriginals, ...applicationTypeProductServicesChanges}));
        setIsApplicationTypeProductServicesChanged(false);
    };

    const handleFileTypes = () => {
        const fileTypes = Object.values(fileTypesChanges);
        configuration.postFileTypes(fileTypes);
        setFileTypesChanges({});
        setOriginalFileTypes(prevOriginals => ({...prevOriginals, ...fileTypesChanges}));
        setIsFileTypesChanged(false);
        console.log('fileTypes', fileTypes);
    };

    const trackChanges = (gridRef, setChanges, setChanged, originalData) => {
        const grid = gridRef.current;

        grid.cellEditEnding.addHandler((s, e) => {
            const editedItem = s.rows[e.row].dataItem;
            const editedField = s.columns[e.col].binding;
            let editedValue = s.activeEditor.value;

            if (editedField === 'isActive') {
                editedValue = s.activeEditor.checked;
            }

            const originalValue = originalData[editedItem.id]?.[editedField];  

            if (editedValue !== originalValue || editedItem[editedField] !== originalValue) {
                setChanges((prevChanges) => {
                    const updatedChanges = { ...prevChanges };
                    updatedChanges[editedItem.id] = {
                        ...editedItem,
                        [editedField]: editedValue,
                    };
                    return updatedChanges;
                });
                setChanged(true);
            }
        });
    };

    const initializeSeason = (flex) => {
        seasonGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item};
        });
        setOriginalSeason(originalData);

        trackChanges(seasonGridRef, setSeasonChanges, setIsSeasonChanged, originalData);
    };

    const initializeApplicationType = (flex) => {
        applicationTypeGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item};
        });
        setOriginalApplicationType(originalData);

        trackChanges(applicationTypeGridRef, setApplicationTypeChanges, setIsApplicationTypeChanged, originalData);
    };

    const initializeEvents = (flex) => {
        eventsGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item};
        });
        setOriginalEvents(originalData);

        trackChanges(eventsGridRef, setEventsChanges, setIsEventsChanged, originalData);
    };

    const initializeApplicationTypeProductAges = (flex) => {
        applicationTypeProductAgesGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item};
        });
        setOriginalApplicationTypeProductAges(originalData);

        trackChanges(applicationTypeProductAgesGridRef, setApplicationTypeProductAgesChanges, setIsApplicationTypeProductAgesChanged, originalData);
    };

    const initializeApplicationTypeProductServices = (flex) => {
        applicationTypeProductServicesGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item};
        });
        setOriginalApplicationTypeProductServices(originalData);

        trackChanges(applicationTypeProductServicesGridRef, setApplicationTypeProductServicesChanges, setIsApplicationTypeProductServicesChanged, originalData);
    };

    const initializeFileTypes = (flex) => {
        fileTypesGridRef.current = flex;
        flex.itemsSourceChanged.addHandler((grid) => {
            if (!isNil(grid.collectionView)) grid.collectionView.trackChanges = true;
        });

        if (!isNil(flex.collectionView)) flex.collectionView.trackChanges = true;
        const originalData = {};
        flex.collectionView?.itemsEdited.forEach((item) => {
            originalData[item.id] = { ...item};
        });
        setOriginalFileTypes(originalData);

        trackChanges(fileTypesGridRef, setFileTypesChanges, setIsFileTypesChanged, originalData);
    };

    const initialize = (flex, ref) => {
        ref.current = flex;
    };

    return{
        loading: <p> loading </p>,
        success: (
            <>
            <div style={{ textAlign: 'center', fontSize: 30,  fontWeight: 'bold', margin: '20px' }}>
                <h1>Checklist</h1>
            </div>
            <div>
                <h2>LK Season</h2>
                <FlexGrid 
                    initialized={(flex) => initializeSeason(flex)}
                    className="explorer-grid"
                    itemsSource={seasonDataQuery?.data}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                >
                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="description" width="*" />
                    <FlexGridColumn header="Έναρξη" binding="dateFrom" width="*" />
                    <FlexGridColumn header="Λήξη" binding="dateTo" width="*" />
                </FlexGrid>
                {isSeasonChanged && (
                    <Button variant="contained" color="primary" onClick={handleSeason}>Save</Button>
                )}
            </div>
            <div>
                <h2>LK Application Type</h2>
                <FlexGrid 
                    initialized={flex => initializeApplicationType(flex)}
                    className="explorer-grid"
                    itemsSource={applicationTypeDataQuery?.data}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                >
                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="description" width="*" />
                    <FlexGridColumn header="Status" binding="isActive" width="*"/>
                </FlexGrid>
                {isApplicationTypeChanged && (
                    <Button variant="contained" color="primary" onClick={handleApplicationType}>Save</Button>
                )}
            </div>
            <div>
                <h2>LK Events</h2>
                <FlexGrid 
                    initialized={flex => initializeEvents(flex)}
                    className="explorer-grid"
                    itemsSource={eventDataQuery?.data}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                >
                    <FlexGridColumn header="Άθλημα" binding="abbr" width="*" />
                    <FlexGridColumn header="Συνολικοί Αθλητές" binding="totalAthletes" width="*" />
                    <FlexGridColumn header="Status" binding="isActive" width="*" />
                </FlexGrid>
                {isEventsChanged && (
                    <Button variant="contained" color="primary" onClick={handleEvents}>Save</Button>
                )}
            </div>
            <div>
                <h2>Application Type Product Ages</h2>
                <FlexGrid 
                    initialized={flex => initializeApplicationTypeProductAges(flex)}
                    className="explorer-grid"
                    itemsSource={applicationTypeProductAgesDataQuery?.data}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                >
                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="productDescription" width="*" isReadOnly={true}/>
                    <FlexGridColumn header="Από Ηλικία" binding="fromAge" width="*" />
                    <FlexGridColumn header="Έως Ηλικία" binding="toAge" width="*" />
                    <FlexGridColumn header="Τιμή" binding="unitPrice" width="*" />
                    <FlexGridColumn header="Έγκυρο από" binding="validFrom" width="*"/>
                    <FlexGridColumn header="Έγκυρο έως" binding="validTo" width="*" />
                    <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                </FlexGrid>
                {isApplicationTypeProductAgesChanged && (
                    <Button variant="contained" color="primary" onClick={handleApplicationTypeProductAges}>Save</Button>
                )}
            </div>
            <div>
                <h2>Application Type Product Services</h2>
                <FlexGrid 
                    initialized={flex => initializeApplicationTypeProductServices(flex)}
                    className="explorer-grid"
                    itemsSource={applicationTypeProductServicesDataQuery?.data}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                >
                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="productDescription" width="*" isReadOnly={true}/>
                    <FlexGridColumn header="Τιμή" binding="unitPrice" width="*" />
                    <FlexGridColumn header="Έγκυρο από" binding="validFrom" width="*"/>
                    <FlexGridColumn header="Έγκυρο έως" binding="validTo" width="*" />
                    <FlexGridColumn header="Ενεργό" binding="isActive" width="*" />
                </FlexGrid>
                {isApplicationTypeProductServicesChanged && (
                    <Button variant="contained" color="primary" onClick={handleApplicationTypeProductServices}>Save</Button>
                )}
            </div>
            <div>
                <h2>LK File Types</h2>
                <FlexGrid 
                    initialized={flex => initializeFileTypes(flex)}
                    className="explorer-grid"
                    itemsSource={fileTypesDataQuery?.data}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                >
                    <FlexGridColumn header="Ενότητα / Περιγραφή" binding="descr" width="*" />
                    <FlexGridColumn header="Status" binding="isActive" width="*" />
                    <FlexGridColumn header="Έκδοση από" binding="lblIssuedBy" width="*" />
                    <FlexGridColumn header="Σχόλια" binding="lblComments" width="*" />
                </FlexGrid>
                {isFileTypesChanged && (
                    <Button variant="contained" color="primary" onClick={handleFileTypes}>Save</Button>
                )}
            </div>
            <div>
                <h2>LK Optional Answers</h2>
                <FlexGrid 
                    initialized={flex => initialize(flex, checklistTables)}
                    className="explorer-grid"
                    itemsSource={optionalAnswerDataQuery?.data}
                    isReadOnly={true}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                />
            </div>
            <div>
                <h2>LK Question</h2>
                <FlexGrid 
                    initialized={flex => initialize(flex, checklistTables)}
                    className="explorer-grid"
                    itemsSource={questionDataQuery?.data}
                    isReadOnly={true}
                    autoSizeMode={1}
                    headersVisibility={3}
                    alternatingRowStep={0}
                />
            </div>
            </>
        ),
        error: <p>error</p>
    }[eventDataQuery.status, seasonDataQuery.status, applicationTypeProductAgesDataQuery.status];
}

export default ChecklistScreen;

